import { render, staticRenderFns } from "./person-edit-reg-number.vue?vue&type=template&id=47ae6732&scoped=true&"
import script from "./person-edit-reg-number.vue?vue&type=script&lang=js&"
export * from "./person-edit-reg-number.vue?vue&type=script&lang=js&"
import style0 from "./person-edit-reg-number.vue?vue&type=style&index=0&id=47ae6732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ae6732",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47ae6732')) {
      api.createRecord('47ae6732', component.options)
    } else {
      api.reload('47ae6732', component.options)
    }
    module.hot.accept("./person-edit-reg-number.vue?vue&type=template&id=47ae6732&scoped=true&", function () {
      api.rerender('47ae6732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/people/person-edit-reg-number.vue"
export default component.exports